import { queryBuilder } from '../../queryBuilder';
import { OutOfHours } from '@intelligent-play-v2/domain';

export const getPitchOutOfHours = async (): Promise<OutOfHours[]> => {
  const { data } = await queryBuilder('GET', 'out-of-hours');
  return data;
};
